import React from 'react';
import { styled } from 'linaria/react';
import t from '@jetshop/intl';
import Button from '../../ui/Button';
import { Field } from 'formik';
import QuantityControl, { QuantityControlWrapper } from './QuantityControl';
import { theme } from '../../Theming/Theming';
import useBuyButtons from '../../ui/hooks/useBuyButtons';

export const buyHeightStyle = `
  height: 46px;
  ${theme.above.lg}{
    height: 60px;
  }
`;

const Wrapper = styled('div')`
  display: flex;
  width: 100%;
  align-items: flex-end;
  ${QuantityControlWrapper} {
    ${buyHeightStyle}
  }
`;

const BuyButton = styled(Button)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 1rem;
  cursor: pointer;
  text-align: center;
  ${buyHeightStyle};
  width: 100%;
  font-size: 1.1rem;
  text-transform: uppercase;
  background: ${theme.productPage.buyButton.background};
  color: ${theme.productPage.buyButton.color};
  &:hover {
    background: ${theme.productPage.buyButton.background};
    color: ${theme.productPage.buyButton.color};
  }
  ${theme.above.md} {
    max-width: 100%;
    font-size: 1.3rem;
  }
`;

const AddToCartWrapper = ({ validationMessage, enableValidation }) => {
  if (!useBuyButtons()) return null;
  return (
    <Wrapper>
      <Field
        id="quantity"
        name="quantity"
        render={({ field, form: { setFieldValue } }) => {
          return (
            <QuantityControl
              field={field}
              setQuantity={setFieldValue}
              quantity={field.value}
            />
          );
        }}
      />
      <BuyButton
        data-testid="add-to-cart"
        type="submit"
        disabled={!!validationMessage}
        onClick={() => {
          enableValidation();
        }}
        className="same"
        style={{
          opacity: !!validationMessage ? 0.7 : 1,
          cursor: !!validationMessage ? 'not-allowed' : 'pointer'
        }}
      >
        {!!validationMessage ? validationMessage : t('Add to cart')}
      </BuyButton>
    </Wrapper>
  );
};

export default AddToCartWrapper;
